import { Icon } from './types';

export const ChevronDownIcon: Icon = (props) => (
  <svg viewBox={'0 0 24 24'} xmlns={'http://www.w3.org/2000/svg'} {...props}>
    <path
      d={
        'M1.7 6.35c.147-.159.348-.28.55-.28.183 0 .365.065.51.199l9.24 8.49 9.24-8.49a.749.749 0 1 1 1.018 1.102l-9.75 9a.748.748 0 0 1-1.019 0l-9.751-9c-.3-.242-.32-.716-.038-1.02Z'
      }
    />
  </svg>
);
